import DataTable from 'components/ui/DataTable/data-table';
import PrimaryButton from 'components/ui/PrimaryButton';
import React, { FC, useState } from 'react';
import EditIcon from '../../../../assets/images/icons/edit.png';
import DeleteIcon from '../../../../assets/images/icons/delete.png';
import { useListFeedbackQuery, IFeedbackFormInput } from 'redux/reducers/Feedback2/index';
import 'css/style.css';
import PermissionWrapper from 'components/ui/PermissionWapper';
import { ActionType } from 'utils/action.type.enum';
import { ModuleCode } from 'utils/module.code.enum';
interface ITraineeDataTable {
  tableHeaders?: () => React.ReactNode;
  onEditClicked: (data: IFeedbackFormInput) => void;
  onDeleteClicked: (data: IFeedbackFormInput) => void;
  onViewClicked: (data: IFeedbackFormInput) => void;
}

const shortener = (string: any) => {
  if (string?.length > 50) {
    string = string.substring(0, 50) + '...';
  }
  return string;
};

const FeedbackTable: FC<ITraineeDataTable> = ({
  tableHeaders,
  onEditClicked,
  onDeleteClicked,
  onViewClicked
}) => {
  const [pageNo, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const { data: feedbackData, isLoading } = useListFeedbackQuery({ pageNo, pageSize });

  const totalRows = feedbackData?.data && feedbackData?.data.length > 0 ? feedbackData?.data?.[0].row_total : 0;

  const totalPages = Math.ceil(totalRows / 10);
  const canNext = pageNo < totalPages;
  const canPrevious = pageNo > 1;


  const columns: any = [
    {
      Header: ' Feedbacks in English',
      Cell: (data: any) => {
        return shortener(data.row.original.question);
      }
    },
    {
      Header: 'Feedbacks in Nepaliss',
      Cell: (data: any) => {
        return shortener(data.row.original.question_np);
      }
    },

    {
      Header: 'Question type',

      Cell: (data: any) => {
        return <>{data.row.original.question_type == 'm' ? 'MCQ' : 'Q&A'}</>;
      }
    },
    {
      Header: '  Action',
      Cell: (data: any) => {
        return (
          <>
            <PermissionWrapper actionType={ActionType.CAN_UPDATE} module_code={ModuleCode.FEEDBACK_MANAGEMENT}>

              <img
                src={EditIcon}
                className="icons"
                onClick={() =>
                  onEditClicked({
                    ...data.row.original
                  })
                }
              />
            </PermissionWrapper>
            <PermissionWrapper actionType={ActionType.CAN_DELETE} module_code={ModuleCode.FEEDBACK_MANAGEMENT}>

            <img
              src={DeleteIcon}
              className="m-2 icons"
              onClick={() => onDeleteClicked(data.row.original)}
            />
            </PermissionWrapper>
          </>
        );
      }
    }
  ];
  return (
    <div className="list form-check-all">
      <DataTable
        columns={columns}
        data={feedbackData?.data || []}
        tableHeaders={tableHeaders}
        isLoading={isLoading}
        pagination={{
          canNext,
          canPrevious,
            prevPage: () => {
            if (canPrevious) {
              setPage((prev) => prev - 1);

            }
          },
          nextPage: () => {
            if (canNext) {
              setPage((prev) => prev + 1);
            }
          }
        }}
      />
      {/* <DataTable
        columns={columns}
        data={feedbackData?.data || []}
        tableHeaders={tableHeaders}
        isLoading={isLoading}
        pagination={{
          canNext: false,
          canPrevious: false,
          nextPage: () => { },
          prevPage: () => { }
        }}
      /> */}
    </div>
  );
};

export default FeedbackTable;
